import type { Role } from "@eai-toolkit/client";

import {
  type BaseQueryState,
  dehydrateQueryStateToStringBase,
  hydrateQueryStateFromStringBase,
} from "../utils/queryStateUtils";

export type RolesQueryState = BaseQueryState<Role>;

const DEFAULT_ROLE_SORT: RolesQueryState["query"]["sort"] = {
  fieldName: "fullName",
  direction: "asc",
};

export function hydrateRolesQueryStateFromString(
  searchString: string,
): RolesQueryState {
  return hydrateQueryStateFromStringBase<Role>(searchString, {
    defaultSort: DEFAULT_ROLE_SORT,
    defaultLimit: 10,
  });
}

export function dehydrateRolesQueryStateToString(
  queryState: RolesQueryState,
): string {
  return dehydrateQueryStateToStringBase<Role>(queryState);
}
